import repository from './repsitory'

const resource = '/parameter'

export default {

    getMachineStatuses () {
        return repository.get(`${resource}/machineStatuses`)
    },
    getShopTypes () {
        return repository.get(`${resource}/shopTypes`)
    },
    getCurrencies () {
        return repository.get(`${resource}/currencies`)
    },
}
